<template>
  <!-- 薪资方案 -->
  <div class="SalarPlan">
    <el-form class="demo-form-inline" label-width="80px"  >

      <el-form-item label="方案名称:" >
        <el-input placeholder="请输入方案名称" v-model="values1"></el-input>
      </el-form-item>

      <el-form-item label="方案类型:" >
        <el-select v-model="values2" placeholder="请选择方案类型" clearable>
          <el-option v-for="item in optionPlan2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="方案状态:" >
        <el-select v-model="values3" placeholder="请选择方案状态"  clearable>
          <el-option v-for="item in optionPlan3" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item style="width: 50%;">
        <el-button type="primary" @click="addProgramme1" class="btns" size="small" icon="el-icon-plus">添加方案</el-button>
        <el-button type="primary" @click="addProgramme11" class="btns" size="small" icon="el-icon-search">查询</el-button>
        <el-button type="primary" @click="addProgramme111" class="btns" size="small" icon="el-icon-close">清空</el-button>
      </el-form-item>

    </el-form>
    <el-table border :data="planArrs" height="850" style="width: 100%" >
      <el-table-column prop="name" label="方案"></el-table-column>
      <el-table-column prop="typeStr" label="方案类型"></el-table-column>
      <el-table-column prop="statusStr" label="方案状态"></el-table-column>
      <el-table-column label="操作" width="150" >
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="delPlan(scope.row.id)">删除</el-button> -->
          <!-- <el-button type="text" size="small" @click="planDetailFun(scope.row.id)">详情</el-button> -->
          <el-button type="text" size="small" @click="editPlan3(scope.row)">编辑</el-button>
          <!-- <el-button type="text" size="small" @click="editPlan1(scope.row.id)">复制</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="planList.pageNum" :page-size="planList.pageSize" layout="total, prev, pager, next"
      :total="planList.total"></el-pagination>



    <el-dialog :title="titleText ? '添加方案' : '编辑方案'" :visible.sync="dialogVisible" width="80%" :before-close="dialogVisibleCle">
      <el-form label-width="80px" :disabled="type === '详情'">
        <el-form-item label="方案名称" style="text-align: left; font-weight: 900; color: #131415;">
          <el-input style="width: 50%;" placeholder="请输入方案名称" v-model="addPlan.planName"></el-input>
        </el-form-item>
        <el-form-item label="底薪" style="text-align: left; font-weight: 900; color: #131415;">
          <el-input style="width: 50%;" placeholder="请输入底薪" v-model="addPlan.jobBasepay"></el-input>
        </el-form-item>
      </el-form>

      <!-- <el-form>
        <el-form-item style="text-align: left;">
          <el-checkbox v-model="addPlan.isClassFee" :disabled="type === '详情'">课时费选择</el-checkbox>
          <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addItem">添加</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="editItem">编辑</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="delItem">删除</el-button>
        </el-form-item>
        <el-form-item style="text-align: left;">
          <el-radio @click.native.prevent="clickitem(item.id)" border v-model="addPlan.classFeeId" :disabled="type === '详情'"
            style="min-width: 130px; height: 230px; margin-left:10px; margin-bottom: 20px; overflow: auto; max-height: 230px;"
            v-for="(item, index) in planDetails" :key="index" :label='item.id'>
            <h3 style="margin-top: -10px;">方案{{ item.planName }}</h3>
            <div style="text-align: left;" v-for="(item1, index1) in item.planDetail" :key="index1">
              <p>学段:{{ item1.gradeName }}</p>
              <p>类型:{{ item1.educationTypeName }}</p>
              <p v-if="item1.classType">学生类型:{{ item1.classType === 1 ? '规划' : item1.classType === 2 ? '线下' : '' }}</p>
              <p>课时费:{{ item1.classFee }}</p>
            </div>
          </el-radio>
        </el-form-item>
      </el-form> -->


      <el-collapse v-model="activeName" accordion class="test_class">
        <el-collapse-item title="课时费" name="1">
          <el-collapse v-model="activeNames" accordion>

            <el-form>
              <el-form-item style="text-align: left;">
                <el-checkbox v-model="addPlan.isClassFee" :disabled="type === '详情'">课时费选择</el-checkbox>
                <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addItem">添加</el-button>
                <el-button :disabled="type === '详情'" type="primary" size="small" @click="editItem">编辑</el-button>
                <el-button :disabled="type === '详情'" type="primary" size="small" @click="delItem">删除</el-button>
              </el-form-item>
              <el-form-item style="text-align: left;">
                <el-radio @click.native.prevent="clickitem(item.id)" border v-model="addPlan.classFeeId" :disabled="type === '详情'"
                  style="min-width: 130px; height: 230px; margin-left:10px; margin-bottom: 20px; overflow: auto; max-height: 230px;"
                  v-for="(item, index) in planDetails" :key="index" :label='item.id'>
                  <h3 style="margin-top: -10px;">方案{{ item.planName }}</h3>
                  <div style="text-align: left;" v-for="(item1, index1) in item.planDetail" :key="index1">
                    <p>学段:{{ item1.gradeName }}</p>
                    <p>类型:{{ item1.educationTypeName }}</p>
                    <p v-if="item1.classType">学生类型:{{ item1.classType === 1 ? '规划' : item1.classType === 2 ? '线下' : '' }}</p>
                    <p>课时费:{{ item1.classFee }}</p>
                  </div>
                </el-radio>
              </el-form-item>
            </el-form>

          </el-collapse>
        </el-collapse-item>
      </el-collapse>


      
      <el-dialog append-to-body :title="isShow ? '课时费添加' : '课时费编辑'" :visible.sync="showDialog" width="50%">
        <el-form>
          <el-form-item label="方案名称" label-width="100px">
            <el-input placeholder="请输入方案名称" v-model="planNames"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-circle-plus-outline" @click="addInput"></el-button>
          </el-form-item>
          <el-form-item style="text-align: center;" v-for="(item, index) in arr" :key="index">
            <p style="margin: 0;padding: 0;text-align: left;">{{ '第' + (index + 1) + '期' }}<el-button
                icon="el-icon-remove-outline" @click="removeItem(index)" style="margin-left: 35px;"></el-button></p>
            <el-select style="width: 80%;" placeholder="请选择课学段" v-model="item.grade" clearable>
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select style="width: 80%;" placeholder="请选择课类型" v-model="item.educationType" clearable>
              <el-option v-for="item in educationType" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input size="small" style="width: 80%;" placeholder="请输入课时费" v-model="item.classFee"></el-input>

            <!-- <el-select style="width: 80%;" placeholder="请选择学生类型" v-model="item.classType" clearable>
              <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select> -->

          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDialog = false">取 消</el-button>
          <el-button type="primary" @click="showSava">确 定</el-button>
        </span>
      </el-dialog>
      <!-- <el-divider content-position="center">奖励项目设置</el-divider> -->
      <!-- <el-form>
        <el-form-item style="text-align: left;">
          <el-checkbox v-model="addPlan.isGradeOneMany">小学生一对多奖励(没有超课次也奖励)</el-checkbox>
          <el-button type="primary" size="mini" style="margin-left: 20px;" @click="pupilBtn">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-table :data="GradeOneManyArr" tooltip-effect="dark" border style="width: 90%"
            @selection-change="handleSelectionChange" ref="multipleTable4" :row-key="(row) => row.id">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="有效期" prop="month">
            </el-table-column>
            <el-table-column prop="classTypeName" label="上课形式">
            </el-table-column>
            <el-table-column prop="fee" label="奖励金额">
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="delPupil(scope.row.id)">删除</el-button>
                <el-button type="text" size="small" @click="editPupil(scope.row.id)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
            :current-page="GradeOneManyList.pageNum" :page-size="GradeOneManyList.pageSize"
            layout="total, prev, pager, next" :total="GradeOneManyList.total">
          </el-pagination>
        </el-form-item>
      </el-form> -->
      <!-- 小学生一对多奖励 添加编辑弹窗 -->
      <el-dialog append-to-body :title="pupilShow ? '添加小学生一对多奖励' : '编辑小学生一对多奖励'" :visible.sync="pupilDialog">
        <el-form label-width="80px">
          <el-form-item label="有效期:">
            <el-checkbox-group v-model="checkList">
              <el-checkbox label="1">一月</el-checkbox>
              <el-checkbox label="2">二月</el-checkbox>
              <el-checkbox label="3">三月</el-checkbox>
              <el-checkbox label="4">四月</el-checkbox>
              <el-checkbox label="5">五月</el-checkbox>
              <el-checkbox label="6">六月</el-checkbox><br />
              <el-checkbox label="7">七月</el-checkbox>
              <el-checkbox label="8">八月</el-checkbox>
              <el-checkbox label="9">九月</el-checkbox>
              <el-checkbox label="10">十月</el-checkbox>
              <el-checkbox label="11">十一月</el-checkbox>
              <el-checkbox label="12">十二月</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="上课形式:">
            <el-select placeholder="请选择" v-model="pupilObj.classType" style="width: 100%;">
              <el-option v-for="item in classTypeArr" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="奖励金额:">
            <el-input v-model="pupilObj.fee" placeholder="请输入奖励金额"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pupilDialog = false">取 消</el-button>
          <el-button type="primary" @click="pupilDialogSave">确 定</el-button>
        </div>
      </el-dialog>



      <!-- <el-form>
        <el-form-item style="display:flex;">
          <el-checkbox v-model="addPlan.isDay1" :disabled="type === '详情'"></el-checkbox>路补奖励选择:
          <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addObligation2">添加</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="editObligation2">编辑</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="delObligation2">删除</el-button>
        </el-form-item>

        <el-form-item style="text-align: left;">
          <el-radio v-for="(item) in PlanDutyList2" :key="item.id" :label="item.id"  :disabled="type === '详情'"
            @click.native.prevent="clickitem111(item.id)" v-model="addPlan.dutyId2"
            style="min-width: 130px; height: 150px; margin-left:20px; overflow: auto;" border>
            <div style="text-align: left; margin-top: -20px;">
              <p> {{ item.wayMoneyName }}</p>
              <p v-for="(evey,index) in item.wayPlanDTOList" :key="index">
                {{ evey.classNum }}课时奖励:{{ evey.classPrice}}
                <span>学段: {{ evey.phaseOfStudying }}</span>
              </p>

              <p>学生类型: {{ item.educationType === 1 ? '网课' : item.educationType === 2 ? '上门' : item.educationType === 3 ? '门店' : '' }}</p>
            </div>
          </el-radio>
        </el-form-item>
      </el-form> -->


      <el-collapse v-model="activeName1" accordion class="test_class" style="margin-top: 30px;">
        <el-collapse-item title="补助" name="1">
          <el-collapse v-model="activeNames" accordion>


            <el-collapse-item title="上门路补" name="1">
              <el-form>
                <el-form-item style="display:flex;">
                  <el-checkbox v-model="addPlan.isDay1" :disabled="type === '详情'"></el-checkbox>路补奖励选择:
                  <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addObligation2">添加</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="editObligation2">编辑</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="delObligation2">删除</el-button>
                </el-form-item>

                <el-form-item style="text-align: left;">
                  <el-radio v-for="(item) in PlanDutyList2" :key="item.id" :label="item.id"  :disabled="type === '详情'"
                    @click.native.prevent="clickitem111(item.id)" v-model="addPlan.dutyId2"
                    style="min-width: 130px; height: 150px; margin-left:20px; overflow: auto;" border>
                    <div style="text-align: left; margin-top: -20px;">
                      <p> {{ item.wayMoneyName }}</p>
                      <p v-for="(evey,index) in item.wayPlanDTOList" :key="index">
                        {{ evey.classNum }}课时奖励:{{ evey.classPrice}}
                        <span>学段: {{ evey.phaseOfStudying }}</span>
                      </p>

                      <p>学生类型: {{ item.educationType === 1 ? '网课' : item.educationType === 2 ? '上门' : item.educationType === 3 ? '门店' : '' }}</p>
                    </div>
                  </el-radio>
                </el-form-item>
              </el-form>
            </el-collapse-item>



            <el-collapse-item title="晚10路补" name="2">
              <el-form>
                <el-form-item style="display:flex;">
                  <el-checkbox v-model="addPlan.isDuty1" :disabled="type === '详情'"></el-checkbox>晚10结束的课补贴:
                  <el-input placeholder="请输入补贴奖励" :disabled="type === '详情'" v-model="addPlan.day" style="width: 200px;"></el-input>
                </el-form-item>
              </el-form>
            </el-collapse-item>


            <el-collapse-item title="日五节" name="3">
              <el-form>
                <el-form-item style="display:flex;">
                  <el-checkbox v-model="addPlan.isDay" :disabled="type === '详情'"></el-checkbox>单日五节课奖励选择:
                  <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addObligation1">添加</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="editObligation1">编辑</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="delObligation1">删除</el-button>
                </el-form-item>

                <el-form-item style="text-align: left;">
                  <el-radio v-for="(item) in PlanDutyList1" :key="item.id" :label="item.id"  :disabled="type === '详情'"
                    @click.native.prevent="clickitem11(item.id)" v-model="addPlan.dutyId1"
                    style="min-width: 130px; height: 150px; margin-left:20px; overflow: auto;" border>
                    <div style="text-align: left; margin-top: -20px;">
                      <p>{{ item.oneClassName }}</p>
                      <p v-for="(evey,index) in item.oneClassPlanDTOList" :key="index">{{ evey.classNum }}节奖励金额:{{ evey. classPrice}}</p>
                    </div>
                  </el-radio>
                </el-form-item>

              </el-form>
            </el-collapse-item>


           
            <el-collapse-item title="远程路补" name="4">
              <el-form>
                <el-form-item style="display:flex;">
                  <!-- <el-checkbox v-model="addPlan.isDuty1" :disabled="type === '详情'"></el-checkbox> -->
                   <span>签约绑定的远程路补</span>
                  <!-- <el-input placeholder="请输入远程路补" :disabled="type === '详情'" v-model="addPlan.day" style="width: 200px;"></el-input> -->
                </el-form-item>
              </el-form>
            </el-collapse-item>


            <el-collapse-item title="社保补助" name="5">
              <el-form>
                <el-form-item style="display:flex;">
                  <el-input placeholder="请输入社保补助" :disabled="type === '详情'" v-model="socialSecurityFee" style="width: 200px;"></el-input>
                </el-form-item>
              </el-form>
           </el-collapse-item>
            
           

          </el-collapse>
        </el-collapse-item>
      </el-collapse>



      <el-collapse v-model="activeName2" accordion class="test_class" style="margin-top: 30px;">
        <el-collapse-item title="义务课时" name="1">
          <el-collapse v-model="activeNames" accordion>

            <el-form>
                <el-form-item style="display:flex;">
                  <el-checkbox v-model="addPlan.isDuty" :disabled="type === '详情'"></el-checkbox>义务课时选择:
                  <el-select placeholder="请选择" v-model="addPlan.dutyMonth" :disabled="type === '详情'">
                    <el-option v-for="item in obligationList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                  <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addObligation">添加</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="editObligation">编辑</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="delObligation">删除</el-button>
                </el-form-item>
                <el-form-item style="text-align: left;">
                  <el-radio v-for="(item) in PlanDutyList" :key="item.id" :label="item.id" :disabled="type === '详情'"
                    @click.native.prevent="clickitem1(item.id)" v-model="addPlan.dutyId"
                    style="min-width: 130px; height: 80px; margin-left:20px; overflow: hidden;" border>
                    <div style="text-align: left; margin-top: -20px;">
                      <p>义务课时数:{{ item.dutyClassNum }}</p>
                      <p>义务课时费:{{ item.dutyClassFee }}</p>
                    </div>
                  </el-radio>
                </el-form-item>
              </el-form>

          </el-collapse>
        </el-collapse-item>
      </el-collapse>



      <el-collapse v-model="activeName3" accordion class="test_class" style="margin-top: 30px;">
        <el-collapse-item title="奖金" name="1">
          <el-collapse v-model="activeNames" accordion>


            <el-collapse-item title="扩科奖金" name="2">
              <el-form>
                <el-form-item style="display:flex;">
                  <span style="opacity: 0;">隐藏中</span>
                  <el-radio  v-model="isExpand"  :label="0">否</el-radio>
                  <el-radio  v-model="isExpand"  :label="1">是</el-radio>
                  <!-- <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addMoonInterpolat">添加</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="editMoonInterpolat">编辑</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="delMoonInterpolat">删除</el-button> -->
                </el-form-item>
                <el-form-item style="text-align: left;">
                  <!-- <el-radio v-for="(item) in MoonInterpolatList" :key="item.id" :label="item.id"  :disabled="type === '详情'"
                    @click.native.prevent="clickitemtwo(item.id)" v-model="addMoon.dutyId"
                    style="min-width: 130px; height: 150px; margin-left:20px; overflow: auto;" border>
                    <div style="text-align: left; margin-top: -20px;">
                      <p>{{ item.interpolateName }}</p>
                      <p v-for="(evey,index) in item.interpolatePlanDTOList" :key="index">{{ evey.classNum }}节奖励金额:{{ evey. classPrice}}</p>
                    </div>
                  </el-radio> -->
                  <el-input placeholder="请输入补贴奖励" :disabled="type === '详情'" v-model="expandFee" style="width: 200px;margin-left: 20px;"></el-input>
                </el-form-item>
              </el-form>
            </el-collapse-item>

            <el-collapse-item title="内推奖励" name="3">
              <el-form>
                <el-form-item style="display:flex;">
                  <el-checkbox v-model="addMoon.isMoon" :disabled="type === '详情'"></el-checkbox>内推奖励:
                  <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addMoonInterpolat">添加</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="editMoonInterpolat">编辑</el-button>
                  <el-button :disabled="type === '详情'" type="primary" size="small" @click="delMoonInterpolat">删除</el-button>
                </el-form-item>
                <el-form-item style="text-align: left;">
                  <el-radio v-for="(item) in MoonInterpolatList" :key="item.id" :label="item.id"  :disabled="type === '详情'"
                    @click.native.prevent="clickitemtwo(item.id)" v-model="addMoon.dutyId"
                    style="min-width: 130px; height: 150px; margin-left:20px; overflow: auto;" border>
                    <div style="text-align: left; margin-top: -20px;">
                      <p>{{ item.interpolateName }}</p>
                      <p v-for="(evey,index) in item.interpolatePlanDTOList" :key="index">{{ evey.classNum }}节奖励金额:{{ evey. classPrice}}</p>
                    </div>
                  </el-radio>
                </el-form-item>
              </el-form>
            </el-collapse-item>


          </el-collapse>
        </el-collapse-item>
      </el-collapse>


      <el-collapse v-model="activeName4" accordion class="test_class" style="margin-top: 30px;"> 
        <el-collapse-item title="扣款项" name="1">
          <el-collapse v-model="activeNames" accordion>

            <el-form style="margin-top: 30px;">
              <el-form-item style="display:flex;">
                上班迟到扣款:   <el-input placeholder="请输入上班迟到扣款" :disabled="type === '详情'" v-model="Deduction1" style="width: 200px;"></el-input>
              </el-form-item>
              <el-form-item style="display:flex;">
                上课迟到扣款:   <el-input placeholder="请输入上课迟到扣款" :disabled="type === '详情'" v-model="Deduction2" style="width: 200px;"></el-input>
              </el-form-item>
              <el-form-item style="display:flex;">
                教学事故扣款:   <el-input placeholder="请输入教学事故扣款" :disabled="type === '详情'" v-model="Deduction3" style="width: 200px;"></el-input>
              </el-form-item>
              <el-form-item style="display:flex;">
                周末/节假日请假扣款:   <el-input placeholder="请输入周末/节假日请假扣款" :disabled="type === '详情'" v-model="Deduction4" style="width: 200px;"></el-input>
              </el-form-item>
            </el-form>

          </el-collapse>
        </el-collapse-item>
      </el-collapse>


      <el-collapse v-model="activeName5" accordion class="test_class" style="margin-top: 30px;"> 
        <el-collapse-item title="社保" name="1">
          <el-collapse v-model="activeName5s" accordion>
            <el-form style="margin-top: 30px;">
              <el-form-item style="display:flex;">
                社保金额:  <el-input placeholder="请输入社保" :disabled="type === '详情'" v-model="socialSecurityWithholdFee" style="width: 200px;"></el-input>
              </el-form-item>
            </el-form>
          </el-collapse>
        </el-collapse-item>
      </el-collapse>


      <!-- 义务课时选择 -->
      <!-- <el-form>
        <el-form-item style="display:flex;">
          <el-checkbox v-model="addPlan.isDuty" :disabled="type === '详情'"></el-checkbox>义务课时选择:
          <el-select placeholder="请选择" v-model="addPlan.dutyMonth" :disabled="type === '详情'">
            <el-option v-for="item in obligationList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addObligation">添加</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="editObligation">编辑</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="delObligation">删除</el-button>
        </el-form-item>
        <el-form-item style="text-align: left;">
          <el-radio v-for="(item) in PlanDutyList" :key="item.id" :label="item.id" :disabled="type === '详情'"
            @click.native.prevent="clickitem1(item.id)" v-model="addPlan.dutyId"
            style="min-width: 130px; height: 80px; margin-left:20px; overflow: hidden;" border>
            <div style="text-align: left; margin-top: -20px;">
              <p>义务课时数:{{ item.dutyClassNum }}</p>
              <p>义务课时费:{{ item.dutyClassFee }}</p>
            </div>
          </el-radio>
        </el-form-item>
      </el-form> -->


      <el-dialog append-to-body :title="obligationShow ? '义务课添加' : '义务课编辑'" :visible.sync="obligationDialog" width="50%" :before-close="obligationDialogCle">
        <el-form>
          <el-form-item style="text-align: left;" label="义务课时数">
            <!-- <p style="margin: 0;padding: 0;text-align: left;">{{ '第' + (index + 1) + '期' }}</p> -->
            <el-input size="small" style="width: 80%;" placeholder="请输入义务课时数" v-model="dutyClassFee"></el-input>
          </el-form-item>
          <el-form-item style="text-align: left;" label="义务课时费">
            <el-input size="small" style="width: 80%;" placeholder="请输入义务课时费" v-model="dutyClassNum"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="obligationDialogCle">取 消</el-button>
          <el-button type="primary" @click="obligationSave">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog append-to-body :title="obligationShow1 ? '单日五节课添加' : '单日五节课编辑'" :visible.sync="obligationDialog1" width="50%" :before-close="obligationDialogCle1">
        <el-form label-width="100px">
          <el-form-item label="方案名称:">
            <el-input v-model="addObj.interpolateName" placeholder="请输入方案名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-circle-plus-outline" @click="addInput1"></el-button>
            <el-button icon="el-icon-remove-outline" @click="removeItem1"></el-button>
          </el-form-item>
          <el-form-item style="text-align: left;" v-for="(item, index) in addObj.planList" :key="index"
            :label="'第' + (index + 1) + '期'">
            <el-input @focus="clickInp(index)" v-model="item.classNum" size="small" style="width: 80%;"
              placeholder="请输入课节数"></el-input>
            <el-input size="small" style="width: 80%;" v-model="item.classPrice" placeholder="请输入奖励金额"></el-input>
            <el-dialog :visible.sync="isMoonShow" width="370px" append-to-body>
              <el-input style="width: 100px;" v-model="num"></el-input>---
              <el-input style="width: 100px;" v-model="num1"></el-input>
              <span class="text" @click="clickText">{{ text }}</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="isMoonShow = false">取 消</el-button>
                <el-button type="primary" @click="determine(index)">确 定</el-button>
              </span>
            </el-dialog>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="obligationDialogCle1">取 消</el-button>
          <el-button type="primary" @click="obligationSave1">确 定</el-button>
        </span>
      </el-dialog>



      <el-dialog append-to-body :title="obligationShow2 ? '路补奖励添加' : '路补奖励编辑'" :visible.sync="obligationDialog2" width="50%" :before-close="obligationDialogCle2">
        <el-form label-width="100px">
          <el-form-item label="方案名称:">
            <el-input v-model="addObj1.interpolateName" placeholder="请输入方案名称"></el-input>
          </el-form-item>
          <el-form-item label="上课方式:">
            <el-select v-model="addObj1.interpolateNames" placeholder="请选择上课方式" style="width:100%;">
              <el-option  v-for="item in interpolateNamesoptions"  :key="item.value"  :label="item.label"  :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-circle-plus-outline" @click="addInput2"></el-button>
            <el-button icon="el-icon-remove-outline" @click="removeItem2"></el-button>
          </el-form-item>
          <el-form-item style="text-align: left;" v-for="(item, index) in addObj1.planList" :key="index"
            :label="'第' + (index + 1) + '期'">
            <el-input @focus="clickInp1(index)" v-model="item.classNum" size="small" style="width: 80%;"
              placeholder="请输入课节数"></el-input>
            <el-input size="small" style="width: 80%;" v-model="item.classPrice" placeholder="请输入奖励金额"></el-input>

            <el-select v-model="item.phaseOfStudying" placeholder="请选择学段" style="width:80%;" clearable>
              <el-option  v-for="item in interpolateNamesoptions1"  :key="item.value"  :label="item.label"  :value="item.value"> </el-option>
            </el-select>

            <el-dialog :visible.sync="isMoonShow" width="370px" append-to-body>
              <el-input style="width: 100px;" v-model="num"></el-input>---
              <el-input style="width: 100px;" v-model="num1"></el-input>
              <span class="text" @click="clickText">{{ text }}</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="isMoonShow = false">取 消</el-button>
                <el-button type="primary" @click="determine1(index)">确 定</el-button>
              </span>
            </el-dialog>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="obligationDialogCle2">取 消</el-button>
          <el-button type="primary" @click="obligationSave2">确 定</el-button>
        </span>
      </el-dialog>





      <!-- <el-form>
        <el-form-item style="text-align: left;">
          <el-checkbox v-model="addPlan.isExce">超课次后每节课奖励</el-checkbox><el-button type="primary" size="mini"
            style="margin-left: 20px;" @click="exceedBtn">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-table :data="ExceTableData" tooltip-effect="dark" border style="width: 90%"
            @selection-change="handleSelectionChange1" ref="multipleTable3" :row-key="(row) => row.id">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="时间" prop="month">
            </el-table-column>
            <el-table-column prop="basicClassNum" label="基础课时数">
            </el-table-column>
            <el-table-column prop="excePredictFee" label="超预计课程奖励(一节课多少钱)" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="delXceed(scope.row.id)">删除</el-button>
                <el-button type="text" size="small" @click="EditXceed(scope.row.id)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
            :current-page="PlanExecList.pageNum" :page-size="PlanExecList.pageSize" layout="total, prev, pager, next"
            :total="PlanExecList.total">
          </el-pagination>
        </el-form-item>
      </el-form> -->
      <!-- 超课次后每节课奖励添加 编辑 -->
      <el-dialog append-to-body :title="exceedShow ? '添加超课次后每节课奖励' : '编辑超课次后每节课奖励'" :visible.sync="exceedDialog">
        <el-form label-width="120px">
          <el-form-item label="有效期:">
            <el-checkbox-group v-model="checkList2">
              <el-checkbox label="1">一月</el-checkbox>
              <el-checkbox label="2">二月</el-checkbox>
              <el-checkbox label="3">三月</el-checkbox>
              <el-checkbox label="4">四月</el-checkbox>
              <el-checkbox label="5">五月</el-checkbox>
              <el-checkbox label="6">六月</el-checkbox><br />
              <el-checkbox label="7">七月</el-checkbox>
              <el-checkbox label="8">八月</el-checkbox>
              <el-checkbox label="9">九月</el-checkbox>
              <el-checkbox label="10">十月</el-checkbox>
              <el-checkbox label="11">十一月</el-checkbox>
              <el-checkbox label="12">十二月</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="基础课时数:">
            <el-input v-model="exceedObj.basicClassNum" placeholder="请输入超课次基础课时数"></el-input>
          </el-form-item>
          <el-form-item label="超预计课程奖励:">
            <el-input v-model="exceedObj.excePredictFee" placeholder="请输入超预计课程奖励"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="exceedDialog = false">取 消</el-button>
          <el-button type="primary" @click="exceedSave">确 定</el-button>
        </div>
      </el-dialog>

    <!--当月内推奖励  -->
     <!-- <el-form>
        <el-form-item style="display:flex;">
          <el-checkbox v-model="addMoon.isMoon" :disabled="type === '详情'"></el-checkbox>当月内推奖励:
          <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addMoonInterpolat">添加</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="editMoonInterpolat">编辑</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="delMoonInterpolat">删除</el-button>
        </el-form-item>
        <el-form-item style="text-align: left;">
          <el-radio v-for="(item) in MoonInterpolatList" :key="item.id" :label="item.id"  :disabled="type === '详情'"
            @click.native.prevent="clickitemtwo(item.id)" v-model="addMoon.dutyId"
            style="min-width: 130px; height: 150px; margin-left:20px; overflow: auto;" border>
            <div style="text-align: left; margin-top: -20px;">
              <p>{{ item.interpolateName }}</p>
              <p v-for="(evey,index) in item.interpolatePlanDTOList" :key="index">{{ evey.classNum }}节奖励金额:{{ evey. classPrice}}</p>
            </div>
          </el-radio>
        </el-form-item>
      </el-form> -->

    <el-dialog :title="isShowDialog ? '当月内推奖励添加' : '当月内推奖励编辑'" :visible.sync="moonVisible" append-to-body :before-close="handleAddMembersShowClose">
      <el-form label-width="100px">
        <el-form-item label="方案名称:">
          <el-input v-model="addObj.interpolateName" placeholder="请输入方案名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-circle-plus-outline" @click="addInput1"></el-button>
          <el-button icon="el-icon-remove-outline" @click="removeItem1"></el-button>
        </el-form-item>
        <el-form-item style="text-align: left;" v-for="(item, index) in addObj.planList" :key="index"
          :label="'第' + (index + 1) + '期'">
          <el-input @focus="clickInp(index)" v-model="item.classNum" size="small" style="width: 80%;"
            placeholder="请输入课节数"></el-input>
          <el-input size="small" style="width: 80%;" v-model="item.classPrice" placeholder="请输入奖励金额"></el-input>
          <el-dialog :visible.sync="isMoonShow" width="370px" append-to-body>
            <el-input style="width: 100px;" v-model="num"></el-input>---
            <el-input style="width: 100px;" v-model="num1"></el-input>
            <span class="text" @click="clickText">{{ text }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="isMoonShow = false">取 消</el-button>
              <el-button type="primary" @click="determine(index)">确 定</el-button>
            </span>
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAddMembersShowClose">取 消</el-button>
        <el-button type="primary" @click='determinePlan'>确 定</el-button>
      </span>
    </el-dialog>

      <!-- 单日五节课奖励选择 -->
      <!-- <el-form>
        <el-form-item style="display:flex;">
          <el-checkbox v-model="addPlan.isDay" :disabled="type === '详情'"></el-checkbox>单日五节课奖励选择:
          <el-button :disabled="type === '详情'" type="primary" size="small" style="margin-left: 100px;" @click="addObligation1">添加</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="editObligation1">编辑</el-button>
          <el-button :disabled="type === '详情'" type="primary" size="small" @click="delObligation1">删除</el-button>
        </el-form-item>

        <el-form-item style="text-align: left;">
          <el-radio v-for="(item) in PlanDutyList1" :key="item.id" :label="item.id"  :disabled="type === '详情'"
            @click.native.prevent="clickitem11(item.id)" v-model="addPlan.dutyId1"
            style="min-width: 130px; height: 150px; margin-left:20px; overflow: auto;" border>
            <div style="text-align: left; margin-top: -20px;">
              <p>{{ item.oneClassName }}</p>
              <p v-for="(evey,index) in item.oneClassPlanDTOList" :key="index">{{ evey.classNum }}节奖励金额:{{ evey. classPrice}}</p>
            </div>
          </el-radio>
        </el-form-item>

      </el-form> -->

      <!-- 晚8点的补课金额 -->
      <!-- <el-form>
        <el-form-item style="display:flex;">
          <el-checkbox v-model="addPlan.isDuty1" :disabled="type === '详情'"></el-checkbox>晚10结束的课补贴:
          <el-input placeholder="请输入补贴奖励" :disabled="type === '详情'" v-model="addPlan.day" style="width: 200px;"></el-input>
        </el-form-item>

      </el-form> -->


      <!-- <el-form>
        <el-form-item style="text-align: left;">
          <el-checkbox v-model="addPlan.isExceOnemany">超课次后一对多奖励</el-checkbox><el-button type="primary" size="mini"
            style="margin-left: 20px;" @click="onManyAdd">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-table :data="onManyTableData" tooltip-effect="dark" border style="width: 90%"
            @selection-change="handleSelectionChange2" ref="multipleTable2" :row-key="(row) => row.id">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="时间" prop="month">
            </el-table-column>
            <el-table-column prop="basicClassNum" label="基础课时数">
            </el-table-column>
            <el-table-column prop="gradeName" label="学段">
            </el-table-column>
            <el-table-column prop="classTypeName" label="上课形式">
            </el-table-column>
            <el-table-column prop="fee" label="奖励金额">
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="delOnMany(scope.row.id)">删除</el-button>
                <el-button type="text" size="small" @click="onManyEdit(scope.row.id)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
            :current-page="onManyList.pageNum" :page-size="onManyList.pageSize" layout="total, prev, pager, next"
            :total="onManyList.total">
          </el-pagination>
        </el-form-item>
      </el-form> -->
      <!-- <el-dialog append-to-body :title="onManyShow ? '添加超课次形式奖励' : '编辑超课次形式奖励'" :visible.sync="onManyDialog">
        <el-form label-width="120px">
          <el-form-item label="有效期:">
            <el-checkbox-group v-model="checkList3">
              <el-checkbox label="1">一月</el-checkbox>
              <el-checkbox label="2">二月</el-checkbox>
              <el-checkbox label="3">三月</el-checkbox>
              <el-checkbox label="4">四月</el-checkbox>
              <el-checkbox label="5">五月</el-checkbox>
              <el-checkbox label="6">六月</el-checkbox><br />
              <el-checkbox label="7">七月</el-checkbox>
              <el-checkbox label="8">八月</el-checkbox>
              <el-checkbox label="9">九月</el-checkbox>
              <el-checkbox label="10">十月</el-checkbox>
              <el-checkbox label="11">十一月</el-checkbox>
              <el-checkbox label="12">十二月</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="基础课时数:">
            <el-input v-model="onManyObj.basicClassNum" placeholder="请输入基础课时数"></el-input>
          </el-form-item>
          <el-form-item label="学段:">
            <el-select v-model="onManyObj.grade" placeholder="请选择学段" style="width: 100%;">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上课形式:">
            <el-select placeholder="请选择" style="width: 100%;" v-model="onManyObj.classType">
              <el-option v-for="item in classTypeArr" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="奖励金额:">
            <el-input v-model="onManyObj.fee" placeholder="请输入奖励金额"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="onManyDialog = false">取 消</el-button>
          <el-button type="primary" @click="onmanySave">确 定</el-button>
        </div>
      </el-dialog> -->
      <!-- 当天超课次奖励 -->
      <!-- <el-form>
        <el-form-item style="text-align: left;">
          <el-checkbox v-model="addPlan.isExceDay">当天超课次奖励</el-checkbox><el-button type="primary" size="mini"
            style="margin-left: 20px;" @click="todayAdd">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-table :data="toDayTableData" tooltip-effect="dark" border style="width: 90%"
            @selection-change="handleSelectionChange3" ref="multipleTable1" :row-key="(row) => row.id">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="时间" prop="month">
            </el-table-column>
            <el-table-column prop="dayExceClassNum" label="当天超课次数">
            </el-table-column>
            <el-table-column prop="dayExceClassFee" label="超课次奖励(一天课多少钱)" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="delToDay(scope.row.id)">删除</el-button>
                <el-button type="text" size="small" @click="toDatEdit(scope.row.id)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange4" @current-change="handleCurrentChange4"
            :current-page="toDayList.pageNum" :page-size="toDayList.pageSize" layout="total, prev, pager, next"
            :total="toDayList.total">
          </el-pagination>
        </el-form-item>
      </el-form> -->
      <el-dialog append-to-body :title="toDayShow ? '添加当天超课次奖励' : '编辑当天超课次奖励'" :visible.sync="toDayDialog">
        <el-form label-width="120px">
          <el-form-item label="有效期:">
            <el-checkbox-group v-model="checkList4">
              <el-checkbox label="1">一月</el-checkbox>
              <el-checkbox label="2">二月</el-checkbox>
              <el-checkbox label="3">三月</el-checkbox>
              <el-checkbox label="4">四月</el-checkbox>
              <el-checkbox label="5">五月</el-checkbox>
              <el-checkbox label="6">六月</el-checkbox><br />
              <el-checkbox label="7">七月</el-checkbox>
              <el-checkbox label="8">八月</el-checkbox>
              <el-checkbox label="9">九月</el-checkbox>
              <el-checkbox label="10">十月</el-checkbox>
              <el-checkbox label="11">十一月</el-checkbox>
              <el-checkbox label="12">十二月</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="当天超课时数:">
            <el-input placeholder="请输入当天超课次数" v-model="toDayObj.dayExceClassNum"></el-input>
          </el-form-item>
          <el-form-item label="当天超课次奖励:">
            <el-input placeholder="请输入当天超课次奖励" v-model="toDayObj.dayExceClassFee"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="toDayDialog = false">取 消</el-button>
          <el-button type="primary" @click="toDaySave">确 定</el-button>
        </div>
      </el-dialog>
      <!-- <el-form>
        <el-form-item style="text-align: left;">
          <el-checkbox v-model="addPlan.isStudentTotal">学生课程累计奖励</el-checkbox><el-button type="primary" size="mini"
            style="margin-left: 20px;" @click="studentCoursesAdd">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-table ref="multipleTable" :row-key="(row) => row.id" :data="studentCoursesTableData" tooltip-effect="dark"
            border style="width: 90%" @selection-change="handleSelectionChange4">
            <el-table-column type="selection" width="55" :reserve-selection="true">
            </el-table-column>
            <el-table-column label="时间" prop="month">
            </el-table-column>
            <el-table-column prop="classTimeNum" label="总课时超过">
            </el-table-column>
            <el-table-column prop="classTimeFee" label="课程累计奖励" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="delStudent(scope.row.id)">删除</el-button>
                <el-button type="text" size="small" @click="studentCoursesEdit(scope.row.id)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange5" @current-change="handleCurrentChange5"
            :current-page="studentCoursesList.pageNum" :page-size="studentCoursesList.pageSize"
            layout="total, prev, pager, next" :total="studentCoursesList.total">
          </el-pagination>
        </el-form-item>
      </el-form> -->
      <el-dialog append-to-body :title="studentCoursesShow ? '添加学生课程累计奖励' : '编辑学生课程累计奖励'"
        :visible.sync="studentCoursesDialog">
        <el-form label-width="120px">
          <el-form-item label="有效期:">
            <el-checkbox-group v-model="checkList5">
              <el-checkbox label="1">一月</el-checkbox>
              <el-checkbox label="2">二月</el-checkbox>
              <el-checkbox label="3">三月</el-checkbox>
              <el-checkbox label="4">四月</el-checkbox>
              <el-checkbox label="5">五月</el-checkbox>
              <el-checkbox label="6">六月</el-checkbox><br />
              <el-checkbox label="7">七月</el-checkbox>
              <el-checkbox label="8">八月</el-checkbox>
              <el-checkbox label="9">九月</el-checkbox>
              <el-checkbox label="10">十月</el-checkbox>
              <el-checkbox label="11">十一月</el-checkbox>
              <el-checkbox label="12">十二月</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="当天超课时数:">
            <el-input placeholder="请输当天超课次数" v-model="studentCoursesObj.classTimeNum"></el-input>
          </el-form-item>
          <el-form-item label="当天超课次奖励:">
            <el-input placeholder="请输入当天超课次奖励" v-model="studentCoursesObj.classTimeFee"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="studentCoursesDialog = false">取 消</el-button>
          <el-button type="primary" @click="studentCoursesSave">确 定</el-button>
        </div>
      </el-dialog>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleCle">取 消</el-button>
        <el-button type="primary" @click="saveFun" v-if="type !== '详情'">保 存</el-button>
      </span>
    </el-dialog>
    <!-- <SalarPlanDialog :detilObj="detilObj" :flog="flog"></SalarPlanDialog> -->
    <!-- 详情 -->
    <el-dialog title="方案详情" :visible.sync="dialogVisible1" width="60%">
      <el-form label-width="200px" style="text-align: left;">
        <el-form-item label="方案名称:">
          {{ this.detilObj.planName }}
        </el-form-item>
        <el-form-item label="底薪:">
          {{ this.detilObj.jobBasepay }}
        </el-form-item>
        <!-- <el-form-item label="是否选择内推奖励:">
          {{ this.detilObj.isRecommender }}
        </el-form-item>
        <el-form-item label="内推奖励金额:">
          {{ this.detilObj.recommenderFee }}
        </el-form-item> -->
        <el-form-item label="是否选择课时费:">
          {{ this.detilObj.isClassFee }}
        </el-form-item>
        <el-form-item label="课时费方案:">
          <div v-for="(item, index) in detilObj.classFeeList" :key="index">
            {{ item }}</div>
        </el-form-item>
        <!-- <el-form-item label="是否选择小学生一对多奖励:">
          {{ this.detilObj.isGradeOneMany }}
        </el-form-item>
        <el-form-item label="小学生一对多奖励方案:">
          <div v-for="(item, index) in detilObj.gradeOneManyList" :key="index">
            {{ item }}</div>
        </el-form-item> -->
        <el-form-item label="是否选择义务课时:">
          {{ this.detilObj.isDuty }}
        </el-form-item>
        <el-form-item label="入职几月:">
          {{ this.detilObj.dutyMonth }}
        </el-form-item>
        <el-form-item label="几号:">
          {{ this.detilObj.day }}
        </el-form-item>
        <el-form-item label="义务课时方案:">
          义务课时数:{{ this.detilObj.dutyClassNum }}
          <div>义务课时费:{{ this.detilObj.dutyClassFee }}</div>
        </el-form-item>
        <!-- <el-form-item label="是否选择超课次奖励:">
          {{ this.detilObj.isExce }}
        </el-form-item>
        <el-form-item label="超课次后每节课奖励方案:">
          <div v-for="(item, index) in detilObj.exceList" :key="index">
            {{ item }}</div>
        </el-form-item>
        <el-form-item label="是否选择超课次后一对多奖励:">
          {{ this.detilObj.isExceOmemany }}
        </el-form-item>
        <el-form-item label="超课次后一对多奖励方案:">
          <div v-for="(item, index) in detilObj.exceOnemanyList" :key="index">
            {{ item }}</div>
        </el-form-item>
        <el-form-item label="是否选择当天超课次奖励:">
          {{ this.detilObj.isExceDay }}
        </el-form-item>
        <el-form-item label="当天超课次奖励方案:">
          <div v-for="(item, index) in detilObj.exceDayList" :key="index">
            {{ item }}</div>
        </el-form-item>
        <el-form-item label="是否选择学生课程累计奖励:">
          {{ this.detilObj.isStudentTotal }}
        </el-form-item>
        <el-form-item label="学生课程累计方案:">
          <div v-for="(item, index) in detilObj.studentTotalList" :key="index">
            {{ item }}</div>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
      </span>
    </el-dialog>




   <el-dialog append-to-body :title="isShows ? '添加方案' : '修改方案'" :visible.sync="addProgramme1show" width="60%" center :before-close="handleaddProgramme1show">
        <el-form>

          <el-form-item label="方案名称" >
            <el-input placeholder="请输入方案名称" v-model="input1"></el-input>
          </el-form-item>

          <el-form-item label="方案类型:">
            <el-select v-model="input2" style="width:100%;" placeholder="请选择方案类型">
                <el-option v-for="item in optionPlan2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="方案状态:"  v-if="!isShows">
            <el-select v-model="input3" style="width:100%;" placeholder="请选择方案状态下">
                <el-option v-for="item in optionPlan3" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="方案详情:">
            <el-form-item>
              <el-button size="small" icon="el-icon-circle-plus-outline" @click="addInput11"></el-button>
              <el-button size="small" icon="el-icon-remove-outline" @click="removeItem11"></el-button>
            </el-form-item>

            <el-form-item>
              <div v-for="(itme,index) in renewalCollectionListWay" :key="index" style="margin-bottom: 20px; ">
                  <el-form-item style="margin-left: 74px;" >
                      <div style="width: 100%; display: flex;">
                        <div style="margin: 10px 0px;width: 35px;"> 区间  </div>
                        <el-input style="margin: 10px 0px; width: 20%;" placeholder="请输入业绩区间下限" v-model="itme.minAmount"></el-input>
                        <div style="margin: 10px 0px;margin-left: 15px;"> ——— </div>
                        <el-input style="margin: 10px 0px; width: 20%;margin-left: 15px;" placeholder="请输入业绩区间上限" v-model="itme.maxAmount"></el-input>
                        <el-input style="margin: 10px 0px; width: 20%;margin-left: 20px;" placeholder="请输入提成比例" v-model="itme.commissionRate"></el-input>
                      </div>
                  </el-form-item>
              </div>
            </el-form-item>

          </el-form-item>

        </el-form>

       
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleaddProgramme1show">取消</el-button>
          <el-button type="primary" @click="handleseachRestAddShowSava">保存</el-button>
        </span>
    </el-dialog>









  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
// import SalarPlanDialog from "./SalarPlanDialog.vue";
export default {
  // components: {
  //   SalarPlanDialog
  // },
  props:{
    type:{
      type: String,
      default:''
    },
    // currentRow:{
    //   type: Object,
    //   default:{}
    // }
  },
  data () {
    return {

     renewalCollectionListWay: [],
     ids: '',
     lePersList1:[],


     values1:'',
     values2:'',
     values3:'',

     optionPlan1:[],
     optionPlan2:[{ id: 1, name: '销售' },{ id: 2, name: '规划师' }],
     optionPlan3:[{ id: 0, name: '禁用' },{ id: 1, name: '启用' }],

     input1:'',
     input2:'',
     input3:'',
     

     obligationDialog1:false,
     obligationShow1:'',

     obligationDialog2:false,
     obligationShow2:'',

    // addMoon:[],
     addMoon:{
        dutyId:'',
        isMoon:'',
      },
     index:'',
     isMoonShow:false,
     text: '+∞',
     num: "0",
     num1: "0",
     addObj: {
        interpolateName: "",
        planList: [],
      },
      addObj1: {
        interpolateName: "",
        interpolateNames: "",
        planList: [],
      },
      moonVisible: false,
      MoonInterpolatList:[],
        viewObj: {
        planName: "",
        planList: [],
      },
      interpolateNamesoptions:[
        {
          value: 1,
          label: '网课'
        },
        {
          value: 2,
          label: '上门'
        },
        {
          value: 3,
          label: '门店'
        },
      ],

      interpolateNamesoptions1:[
        {
          value: 1,
          label: '小学'
        },
        {
          value: 2,
          label: '初高'
        }
      ],

      Deduction1:'',
      Deduction2:'',
      Deduction3:'',
      Deduction4:'',

      activeName: '',
      activeName1: '',
      activeName2: '',
      activeName3: '',
      activeName4: '',
      activeNames: '',
      isShowDialog:false,
      optionPlan: [],
      values: '',
      dialogVisible1: false,
      detilObj: {
      },
      detilShow: false,//详情显示隐藏
      classTypeArr: [{
        value: 1,
        name: '1v1'
      }, {
        value: 2,
        name: '1v2'
      }, {
        value: 3,
        name: '1v3'
      },
      ],
      planNames: "",
      titleText: true,
      dutyObj: {//义务课时费绑定
        dutyClassFee: "",//义务课时费
        dutyClassNum: "",//义务课时数
        id: ""
      },
      PlanDutyList: [],//义务课时选择
      PlanDutyList1: [],//义务课时选择
      PlanDutyList2: [],//义务课时选择

      planArr: [],//所有方案
      GradeOneManyArr: [],//小学生一对多奖励表格
      ExceTableData: [],//超课次后每节课奖励表格
      onManyTableData: [],//超课次后一对多奖励表格
      toDayTableData: [],//当天超课次奖励
      studentCoursesTableData: [],//学生课程累计奖励
      GradeOneManyList: {//小学生一对多奖励分页
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      planName: "",//方案名称搜索
      planList: {//所有方案分页
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      onManyList: {
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      PlanExecList: {
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      toDayList: {
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      studentCoursesList: {
        total: 0, //总条数
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },

      addPlan: {//添加方案
        isDay1: false,
        dutyId2:'',
        isDuty1: false,
        id: "",
        dutyId: '',//义务课时费表id
        dutyId1: '',
        planName: "",//方案名称
        isRecommender: false,//是否选了内推奖励
        recommenderFee: "",//内推奖励金额
        day: "",
        isDuty: false,
        isClassFee: false,
        isMoon:false,
        isDay:false,
        execId: [],//超课次表id
        jobBasepay: "",//底薪
        classFeeId: "",//课时费表id
        dutyMonth: "",//义务课时费有效期
        isGradeOneMany: false,//是否选了小学生一对多 0否 1是
        isExce: false,//是否选了超课次 0否 1是
        isExceOnemany: false,//是否选了超课次后一对多奖励 0否 1是
        isExceDay: false,//是否选了当天超课次 0否 1是
        isStudentTotal: false,//是否选了学生课程累计 0否 1是
        exceDayId: [],//当天超课次表id
        exceOnemanyId: [],//超课次一对多奖励表id
        gradeOneManyId: [],//小学生一对多表id
        studentTotalId: [],//学生课程累计表id
      },
      pupilShow: true,// 判断小学生一对多奖励是添加或者编辑
      pupilDialog: false,
      exceedShow: true,//判断超课次后每节课奖励是添加还是编辑
      exceedDialog: false,
      onManyShow: true,//判断超课次形式奖励是添加还是编辑
      onManyDialog: false,
      toDayShow: true,//判断当天超课次奖励是添加还是编辑
      toDayDialog: false,
      studentCoursesShow: true,//判断学生课程累计奖励是添加还是编辑
      studentCoursesDialog: false,
      isShow: true,//根据该字段判断是添加还是编辑
      showDialog: false,//添加方案显示隐藏
      obligationDialog: false,//义务课时方案
      obligationShow: false,//据该字段判断是添加还是编辑
      pupilObj: {//小学生一对多奖励添加编辑弹窗
        id: '',
        month: "",//月份
        classType: "",//上课形式
        fee: '',//奖励金额
      },
      exceedObj: {//超课次后每节课奖励
        id: '',
        month: "",//月份
        basicClassNum: "",//基础课时数
        excePredictFee: "",//超预计课程奖励
      },
      onManyObj: {//超课次后一对多奖励
        basicClassNum: "",//基础课时数
        grade: "",//学段
        classType: "",//上课形式
        fee: "",//奖励金额
        id: ''
      },
      toDayObj: {//当天超课次奖励
        id: "",
        month: "",//月份
        dayExceClassNum: "",//当天超过课时数
        dayExceClassFee: "",//超课次奖励
      },
      studentCoursesObj: {//学生课程累计
        id: "",
        month: '',//月份
        classTimeNum: "",//课时数
        classTimeFee: "",//课时费
      },
      arr: [{ grade: "", educationType: "", classFee: "" }],
      planDetails: [{ gradeName: "", educationType: "", classFee: "" }],
      checkList: [],//小学生一对多奖励月份
      checkList2: [],//超课次后每节课奖励月份
      checkList3: [],//超课次后一对多奖励月份
      checkList4: [],//当天超课次奖励月份
      checkList5: [],//学生课程累计奖励
      value: '',
      options: [{
        value: "1",
        label: '小学'
      }, {
        value: "2",
        label: '初中'
      }, {
        value: "3",
        label: '高中'
      }, {
        value: "4",
        label: '规划课'
      }, {
        value: "5",
        label: '家庭教育课'
      }],

      options1: [{
        value: 1,
        label: '规划'
      }, {
        value: 2,
        label: '线下'
      }],

      educationType: [{ value: "1", label: '网课' }, { value: "2", label: '线下' }, { value: "3", label: '门店' }],
      obligationList: [
        {
          id: '1',
          name: '入职1个月'
        },
        {
          id: '2',
          name: '入职2个月'
        },
        {
          id: '3',
          name: '入职3个月'
        },
        {
          id: '4',
          name: '入职4个月',
        }, {
          id: '5',
          name: '入职5个月'
        }
        , {
          id: '6',
          name: '入职6个月'
        }
        , {
          id: '7',
          name: '入职7个月'
        }
        , {
          id: '8',
          name: '入职8个月'
        }
        , {
          id: '9',
          name: '入职9个月'
        }
        , {
          id: '10',
          name: '入职10个月'
        }
        , {
          id: '11',
          name: '入职11个月'
        }
        , {
          id: '12',
          name: '入职12个月'
        }
      ],
      dialogVisible: false,

      isExpand: 0,
      expandFee: '',


      dutyClassFee: "",
      dutyClassNum: "",


      socialSecurityFee: "",
      socialSecurityWithholdFee: "",

      isSocialSecurity: "",
      isSocialSecurityWithhold: "",


      activeName5: "",
      activeName5s: "",


      addProgramme1show:false,
      isShows: false,

      planArrs: [],

    }
  },
  created () {
    // this.getOptions()
    // this.getPupilList()
    // this.getOnMany()
    // this.getPlanExec()
    // this.getOnMany()
    // this.getToDay()
    // this.getStudentCourses()
    // this.getPlanData()
    // this.salaryPlanDuty()
    // this.getListArr()
    // this.getPlanList()
    // this.getMoonInterpolatList()
  },
  mounted(){
    if(this.currentRow){
       this.addPlan.id = this.currentRow.id
    }
    this.handleinitlist()
    this.handleGetInitAll()

  },
  methods: {

      addProgramme11(){
        this.handleinitlist()
      },

      addProgramme111(){
        this.values1 = ''
        this.values2 = ''
        this.values3 = ''
        this.planList.pageNum = 1
        this.planList.pageSize = 10
        this.handleinitlist()
      },

      handleinitlist(){
        axios.post(`${apiBaseUrl}/commissionPlan/queryPlaneList`, { 
          pageNo: this.planList.pageNum, 
          pageSize: this.planList.pageSize, 
          type: this.values2,
          status: this.values3,
          name: this.values1,
        },{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
          console.log(res)
          let data = res.data.data
          if(res.data.code == 200){
              this.planList.total = data.total
              this.planArrs = data.records
              this.$message.success('查询成功')
           }else{
             this.planList.total = 0
             this.planArrs = []
           }
        }).catch((error) => {
          this.planList.total = 0
          this.planArrs = []
          console.log(error);
          this.$message.error(error)
        });
      },

      handleGetInitAll(){
        axios.get(`${apiBaseUrl}/commissionPlan/getPlaneList`,{ headers:{  'authorization': sessionStorage.getItem('tokenInfo')  } }).then((res)=>{
          let data = res.data.data
          if(res.data.code == 200){
            this.optionPlan1 = data
          }else{
            this.optionPlan1 = []
          }
        }).catch((error)=>{
           this.optionPlan1 = []
        })
      },

      removeItem11 () {
        if (this.renewalCollectionListWay.length > 1) {
            this.renewalCollectionListWay.pop()
        } else {
            this.renewalCollectionListWay.splice(0, this.renewalCollectionListWay.length)
        }
      },

      addInput11 () {
        this.renewalCollectionListWay.push({
            minAmount:'',
            maxAmount:'',
            commissionRate:'',
        })
      },

    handleseachRestAddShowSava(){

      let obj = { url:'', data:{} }


      this.renewalCollectionListWay.forEach((item, index) => {
        item.numAmount = index + 1
      })

      if(this.isShows){
        obj.url = `/commissionPlan/addPlane`
        obj.data = { 
          name: this.input1,
          type: this.input2,
          details: this.renewalCollectionListWay,
        }
      }else{
        obj.url = `/commissionPlan/updatePlane`
        obj.data = { 
          id: this.ids,
          name: this.input1,
          type: this.input2,
          status: this.input3,
          details: this.renewalCollectionListWay,
        }
      }

      axios.post(`${apiBaseUrl}${obj.url}`, obj.data, { headers:{  'authorization': sessionStorage.getItem('tokenInfo')  } }).then((res)=>{
        if(res.data.code == 200){
            this.$message.success('添加成功')
            this.isShows = false
            this.addProgramme1show = false
            this.renewalCollectionListWay = []
            this.handleinitlist()
          }else{
            this.$message.error(res.data.message)
          }
        }).catch((error)=>{
          this.$message.error(error)
      })
    },

    addProgramme1 () {
      this.ids = ''
      this.isShows = true
      this.addProgramme1show = true
    },


    handleaddProgramme1show(){
      this.isShows = false
      this.addProgramme1show = false
      this.renewalCollectionListWay = []
      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
    },


    editPlan3 (row) {
      this.ids = row.id

      this.input1 = row.name
      this.input2 = row.type
      this.input3 = row.status
      this.renewalCollectionListWay = row.details

      this.isShows = false
      this.addProgramme1show = true
    },

    handleAddMembersShowClose(){
      this.moonVisible = false
    },

    seleOption () {
      console.log(this.values);
      axios
        .post(`${apiBaseUrl}/salaryPlan/salaryPlanList`, { pageNum: this.planList.pageNum, pageSize: this.planList.pageSize, planName: this.values },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.planList.total = res.data.data.total
          this.planArr = res.data.data.records
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //select搜索
    getOptions () {
      axios
        .get(`${apiBaseUrl}/salaryPlan/salaryPlanNameList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.optionPlan = res.data.data
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取所有方案
    getPlanList () {
      axios
        .post(`${apiBaseUrl}/salaryPlan/salaryPlanList`, { pageNum: this.planList.pageNum, pageSize: this.planList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.planList.total = res.data.data.total
          this.planArr = res.data.data.records
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取小学生一对多奖励数据
    getPupilList () {
      axios
        .post(`${apiBaseUrl}/salaryPlanGradeOneMany/getList`, { pageNum: this.GradeOneManyList.pageNum, pageSize: this.GradeOneManyList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.GradeOneManyList.total = res.data.data.total
          this.GradeOneManyArr = res.data.data.records
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //小学生一对多保存
    pupilDialogSave () {
      let data = {
        month: this.checkList.toString(),
        classType: this.pupilObj.classType,
        fee: this.pupilObj.fee,
        id: this.pupilObj.id
      }
      if (this.pupilShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanGradeOneMany/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.getPupilList()
              this.pupilDialog = false
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanGradeOneMany/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.getPupilList()
              this.pupilDialog = false
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //添加方案 编辑方案保存
    saveFun () {
      let data = {
        id: this.addPlan.id,
        planName: this.addPlan.planName,
        jobBasepay: this.addPlan.jobBasepay,
        isRecommender: this.addPlan.isRecommender ? '1' : '0',
        recommenderFee: this.addPlan.recommenderFee,
        isClassFee: this.addPlan.isClassFee ? '1' : '0',
        classFeeId: this.addPlan.classFeeId,
        isGradeOneMany: this.addPlan.isGradeOneMany ? '1' : '0',
        gradeOneManyId: this.addPlan.gradeOneManyId.toString(),
        isDuty: this.addPlan.isDuty ? '1' : '0',
        dutyMonth: this.addPlan.dutyMonth,
        day: this.addPlan.day,
        dutyId: this.addPlan.dutyId,
        isExce: this.addPlan.isExce ? '1' : '0',
        execId: this.addPlan.execId.toString(),
        isExceOnemany: this.addPlan.isExceOnemany ? '1' : '0',
        exceOnemanyId: this.addPlan.exceOnemanyId.toString(),
        isExceDay: this.addPlan.isExceDay ? '1' : '0',
        exceDayId: this.addPlan.exceDayId.toString(),
        isStudentTotal: this.addPlan.isStudentTotal ? '1' : '0',
        studentTotalId: this.addPlan.studentTotalId.toString(),

        isRecommender: this.addMoon.isMoon ? 1 : 0,
        interpolateId: this.addMoon.dutyId,
        isOneClass: this.addPlan.isDay ? 1 : 0,
        oneClassId: this.addPlan.dutyId1,
        isNightEight: this.addPlan.isDuty1 ? 1 : 0,
        nightEightMoney: this.addPlan.day,

        isWayMoney: this.addPlan.isDay1 ? 1 : 0,
        wayId: this.addPlan.dutyId2,


        isExpand: this.isExpand ,
        expandFee:this.expandFee,

        //是否开启社保补助 0否 1是
        isSocialSecurity: this.socialSecurityFee ? 1 : 0,
         //社保补助
        socialSecurityFee: this.socialSecurityFee,
        //是否开启社保 0否 1是
        isSocialSecurityWithhold: this.socialSecurityWithholdFee ? 1 : 0,
        //社保
        socialSecurityWithholdFee: this.socialSecurityWithholdFee,
                
      }
      if (this.titleText == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlan/salaryPlanAdd`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getPlanList()
              this.$message.success(res.data.message)
              this.dialogVisible = false
              this.socialSecurityFee = ''
              this.isSocialSecurity = ''
              this.isSocialSecurityWithhold = ''
              this.socialSecurityWithholdFee = ''


              this.$emit('handleEvent',false)

            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlan/salaryPlanUpdate`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getPlanList()
              this.dialogVisible = false
              this.$message.success(res.data.message)
              this.socialSecurityFee = ''
              this.isSocialSecurity = ''
              this.isSocialSecurityWithhold = ''
              this.socialSecurityWithholdFee = ''
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //删除方案
    delPlan (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlan/salaryPlanDel?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getPlanList()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    editPlan1(id){
      axios.get(`${apiBaseUrl}/salaryPlan/salaryCopy?id=${id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}) .then((res) => {
        if (res.data.code == 200) {
           this.$message.success(res.data.message)
        }else{
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        this.$message.error(error)
      });
    },

    //编辑方案回显
    editPlan (id) {
      this.addPlan.id = id
      this.titleText = false
      this.dialogVisible = true
      axios
        .get(`${apiBaseUrl}/salaryPlan/salaryPlanOne?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.addPlan.planName = res.data.data.planName
          this.addPlan.jobBasepay = res.data.data.jobBasepay
          this.addPlan.isRecommender = res.data.data.isRecommender == 1 ? true : false
          this.addPlan.isClassFee = res.data.data.isClassFee == 1 ? true : false
          this.addPlan.recommenderFee = res.data.data.recommenderFee
          this.addPlan.isExce = res.data.data.isExce == 1 ? true : false
          this.addPlan.classFeeId = res.data.data.classFeeId
          this.addPlan.isGradeOneMany = res.data.data.isGradeOneMany == 1 ? true : false


          this.addMoon.isMoon = res.data.data.isRecommender == 1 ? true : false
          this.addMoon.dutyId = res.data.data.interpolateId

          this.addPlan.isDay = res.data.data.isOneClass == 1 ? true : false
          this.addPlan.dutyId1 = res.data.data.oneClassId

          this.addPlan.isDuty1 = res.data.data.isNightEight == 1 ? true : false
          this.addPlan.day = res.data.data.nightEightMoney


          this.addPlan.isDay1 =  res.data.data.isWayMoney == 1 ? true : false
          this.addPlan.dutyId2 = res.data.data.wayId


          this.isExpand  = res.data.data.isExpand 
          this.expandFee = res.data.data.expandFee 

           //是否开启社保补助 0否 1是
          this.isSocialSecurity =  res.data.data.socialSecurityFee ? 1 : 0
          //社保补助
          this.socialSecurityFee =  res.data.data.socialSecurityFee
          //是否开启社保 0否 1是
          this.isSocialSecurityWithhold =  res.data.data.socialSecurityWithholdFee ? 1 : 0
          //社保
          this.socialSecurityWithholdFee =  res.data.data.socialSecurityWithholdFee


          let e = res.data.data.gradeOneManyId.split(",").map(Number)
          if (e.length > 0) {
            this.$nextTick(() => {
              this.GradeOneManyArr.forEach(item => {
                if (e.some(user => user === item.id)) {
                  // 存在添加
                  // this.$refs.multipleTable4.toggleRowSelection(item, true)
                }
              })
            })
          }
          this.addPlan.isDuty = res.data.data.isDuty == 1 ? true : false
          this.addPlan.dutyMonth = res.data.data.dutyMonth
          this.addPlan.day = res.data.data.day
          this.addPlan.dutyId = res.data.data.dutyId
          this.addPlan.isExce = res.data.data.isExce == 1 ? true : false
          let d = res.data.data.execId.split(",").map(Number)
          if (d.length > 0) {
            this.$nextTick(() => {
              this.ExceTableData.forEach(item => {
                if (d.some(user => user === item.id)) {
                  // 存在添加
                  // this.$refs.multipleTable3.toggleRowSelection(item, true)
                }
              })
            })
          }
          this.addPlan.isExceOnemany = res.data.data.isExceOnemany == 1 ? true : false
          let c = res.data.data.exceOnemanyId.split(",").map(Number)
          if (c.length > 0) {
            this.$nextTick(() => {
              this.onManyTableData.forEach(item => {
                if (c.some(user => user === item.id)) {
                  // 存在添加
                  // this.$refs.multipleTable2.toggleRowSelection(item, true)
                }
              })
            })
          }
          this.addPlan.isExceDay = res.data.data.isExceDay == 1 ? true : false
          let b = res.data.data.exceDayId.split(",").map(Number)
          if (b.length > 0) {
            this.$nextTick(() => {
              this.toDayTableData.forEach(item => {
                if (b.some(user => user === item.id)) {
                  // 存在添加
                  this.$refs.multipleTable1.toggleRowSelection(item, true)
                }
              })
            })
          }
          this.addPlan.isStudentTotal = res.data.data.isStudentTotal == 1 ? true : false
          let a = res.data.data.studentTotalId.split(",").map(Number)
          if (a.length > 0) {
            this.$nextTick(() => {
              this.studentCoursesTableData.forEach(item => {
                if (a.some(user => user === item.id)) {
                  // 存在添加
                  // this.$refs.multipleTable.toggleRowSelection(item, true)
                }
              })
            })
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //方案详情
    planDetailFun (id) {
      this.dialogVisible1 = true
      axios
        .get(`${apiBaseUrl}/salaryPlan/salaryPlanDetail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.detilObj = res.data.data
          console.log(this.detilObj);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addInput () {
      this.arr.push({
        grade: "",
        educationType: "",
        classFee: ""
      });
    },
    //减少输入框
    removeItem (index) {
      // if (this.planDetail.length > 1) {
      this.arr.splice(index, 1);;
      // } else {
      //   this.planDetail.splice(0, this.planDetail.length);
      // }
    },
    //课时费添加方案
    addItem () {
      this.isShow = true
      this.showDialog = true
      this.planNames = ""
      this.arr = [{
        grade: "",
        educationType: "",
        classFee: ""
      }]
    },
    //课时费删除方案
    editItem () {
      if (this.addPlan.classFeeId != "") {
        this.isShow = false
        this.showDialog = true
        axios
          .get(`${apiBaseUrl}/salaryPlanClassFee/detail?id=${this.addPlan.classFeeId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.planNames = res.data.data.planName
              this.arr = res.data.data.planDetail
              this.planObj.id = res.data.data.id
              this.planNames = res.data.data.planName
              this.addPlan.classFeeId = ""
              this.$message.success(res.data.success)
            } else {
              this.$message.error(res.data.success)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },
    //删除
    delItem () {
      if (this.addPlan.classFeeId != "") {
        axios
          .get(`${apiBaseUrl}/salaryPlanClassFee/delete?id=${this.addPlan.classFeeId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getListArr()
              this.addPlan.classFeeId = ""
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },
    //小学生一对多奖励添加
    pupilBtn () {
      this.checkList = []
      this.pupilObj.classType = "",
        this.pupilObj.fee = ""
      this.pupilShow = true
      this.pupilDialog = true
    },
    //小学生一对多奖励表格编辑
    editPupil (id) {
      this.pupilShow = false
      this.pupilDialog = true
      this.pupilObj.id = id
      axios
        .get(`${apiBaseUrl}/salaryPlanGradeOneMany/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.checkList = res.data.data.month.split(",")
          this.pupilObj.classType = res.data.data.classType
          this.pupilObj.fee = res.data.data.fee
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //小学生一对多奖励删除
    delPupil (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanGradeOneMany/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getPupilList()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后每节课奖励表格
    getPlanExec () {
      axios
        .post(`${apiBaseUrl}/salaryPlanExec/getList`, { pageNum: this.PlanExecList.pageNum, pageSize: this.PlanExecList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.ExceTableData = res.data.data.records
          this.PlanExecList.total = res.data.data.total
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后每节课奖励添加 编辑保存
    exceedSave () {
      let data = {
        month: this.checkList2.toString(),
        basicClassNum: this.exceedObj.basicClassNum,
        excePredictFee: this.exceedObj.excePredictFee,
        id: this.exceedObj.id
      }
      if (this.exceedShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanExec/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getPlanExec()
              this.exceedDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanExec/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getPlanExec()
              this.exceedDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //超课次后每节课奖励添加
    exceedBtn () {
      this.checkList2 = []
      this.exceedObj.basicClassNum = ""
      this.exceedObj.excePredictFee = ""
      this.exceedShow = true
      this.exceedDialog = true
    },
    //超课次后每节课奖励编辑
    EditXceed (id) {
      this.exceedObj.id = id
      this.exceedShow = false
      this.exceedDialog = true
      axios
        .get(`${apiBaseUrl}/salaryPlanExec/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.exceedObj.basicClassNum = res.data.data.basicClassNum
          this.checkList2 = res.data.data.month.split(",")
          this.exceedObj.excePredictFee = res.data.data.excePredictFee
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次表格删除
    delXceed (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanExec/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getPlanExec()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后一对多奖励表格
    getOnMany () {
      axios
        .post(`${apiBaseUrl}/salaryPlanExceOnemany/getList`, { pageNum: this.onManyList.pageNum, pageSize: this.onManyList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.onManyTableData = res.data.data.records
          this.onManyList.total = res.data.data.total
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后一对多奖励添加
    onManyAdd () {
      this.checkList3 = []
      this.onManyObj.basicClassNum = ""
      this.onManyObj.grade = ""
      this.onManyObj.classType = ""
      this.onManyObj.fee = ""
      this.onManyShow = true
      this.onManyDialog = true
    },
    //超课次后一对多奖励编辑
    onManyEdit (id) {
      this.onManyShow = false
      this.onManyDialog = true
      this.onManyObj.id = id
      axios
        .get(`${apiBaseUrl}/salaryPlanExceOnemany/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.checkList3 = res.data.data.month.split(",")
          this.onManyObj.basicClassNum = res.data.data.basicClassNum
          this.onManyObj.grade = res.data.data.grade
          this.onManyObj.classType = res.data.data.classType
          this.onManyObj.fee = res.data.data.fee
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后一对多奖励删除
    delOnMany (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanExceOnemany/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getOnMany()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.success)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //超课次后一对多奖励 添加 编辑 保存
    onmanySave () {
      let data = {
        month: this.checkList3.toString(),
        basicClassNum: this.onManyObj.basicClassNum,
        grade: this.onManyObj.grade,
        id: this.onManyObj.id,
        fee: this.onManyObj.fee,
        classType: this.onManyObj.classType
      }
      if (this.onManyShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanExceOnemany/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getOnMany()
              this.onManyDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanExceOnemany/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getOnMany()
              this.onManyDialog = false
              this.$message.success(res.data.success)
            } else {
              this.$message.error(res.data.success)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //当天超课次奖励添加
    todayAdd () {
      this.checkList4 = []
      this.toDayObj.dayExceClassFee = ""
      this.toDayObj.dayExceClassNum = ""
      this.toDayShow = true
      this.toDayDialog = true
    },
    //当天超课次奖励编辑
    toDatEdit (id) {
      this.toDayShow = false
      this.toDayDialog = true
      this.toDayObj.id = id
      axios
        .get(`${apiBaseUrl}/salaryPlanExceDay/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.checkList4 = res.data.data.month.split(",")
          this.toDayObj.dayExceClassFee = res.data.data.dayExceClassFee
          this.toDayObj.dayExceClassNum = res.data.data.dayExceClassNum
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //当天超课次删除
    delToDay (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanExceDay/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getToDay()
            this.$message.success(res.data.message)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //当天超课次添加编辑保存
    toDaySave () {
      let data = {
        month: this.checkList4.toString(),
        dayExceClassFee: this.toDayObj.dayExceClassFee,
        dayExceClassNum: this.toDayObj.dayExceClassNum,
        id: this.toDayObj.id
      }
      if (this.toDayShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanExceDay/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getToDay()
              this.toDayDialog = false
              this.$message.success(res.data.success)
            } else {
              this.$message.error(res.data.success)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanExceDay/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getToDay()
              this.toDayDialog = false
              this.$message.success(res.data.success)
            } else {
              this.$message.error(res.data.success)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //获取当天超课次奖励数据
    getToDay () {
      axios
        .post(`${apiBaseUrl}/salaryPlanExceDay/getList`, { pageSize: this.toDayList.pageSize, pageNum: this.toDayList.pageNum },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.toDayTableData = res.data.data.records
          this.toDayList.total = res.data.data.total
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取学生课程累计表格
    getStudentCourses () {
      axios
        .post(`${apiBaseUrl}/salaryPlanStudentTotal/getList`, { pageNum: this.studentCoursesList.pageNum, pageSize: this.studentCoursesList.pageSize },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.studentCoursesTableData = res.data.data.records
          this.studentCoursesList.total = res.data.data.total
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //学生课程累计添加
    studentCoursesAdd () {
      this.checkList5 = []
      this.studentCoursesObj.classTimeNum = ""
      this.studentCoursesObj.classTimeFee = ""
      this.studentCoursesShow = true
      this.studentCoursesDialog = true
    },
    //学生课程累计编辑
    studentCoursesEdit (id) {
      this.studentCoursesShow = false
      this.studentCoursesDialog = true
      this.studentCoursesObj.id = id
      axios
        .get(`${apiBaseUrl}/salaryPlanStudentTotal/detail?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.checkList5 = res.data.data.month.split(",")
          this.studentCoursesObj.classTimeFee = res.data.data.classTimeFee
          this.studentCoursesObj.classTimeNum = res.data.data.classTimeFee
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //学生课程累计添加 编辑 保存
    studentCoursesSave () {
      let data = {
        month: this.checkList5.toString(),
        classTimeFee: this.studentCoursesObj.classTimeFee,
        classTimeNum: this.studentCoursesObj.classTimeNum,
        id: this.studentCoursesObj.id
      }
      if (this.studentCoursesShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanStudentTotal/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getStudentCourses()
              this.studentCoursesDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanStudentTotal/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.getStudentCourses()
              this.studentCoursesDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //学生课程累计删除
    delStudent (id) {
      axios
        .get(`${apiBaseUrl}/salaryPlanStudentTotal/delete?id=${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.getStudentCourses()
            this.$message.success(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取所有课时费方案
    getPlanData () {
      axios
        .post(`${apiBaseUrl}/salaryPlanClassFee/getList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            // this.PlanDutyList = res.data.data.records
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取义务课列表
    salaryPlanDuty () {
      axios.get(`${apiBaseUrl}/oneClass/getList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
           this.PlanDutyList1 = res.data.data
        })
        .catch((error) => {
          console.log(error);
        });


      axios.post(`${apiBaseUrl}/salaryPlanDuty/getList`, { pageNum: 1, pageSize: 10 },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.PlanDutyList = res.data.data.records
        })
        .catch((error) => {
          console.log(error);
        });



       this.handleGETway_plan()

    },


    handleGETway_plan(){
        axios.get(`${apiBaseUrl}/way_plan/getList`,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          this.PlanDutyList2 = res.data.data
        }).catch((error) => {});
    },

    //义务课方案添加
    addObligation () {
      this.obligationShow = true
      this.obligationDialog = true
      this.dutyClassFee = ""
      this.dutyClassNum = ""
      this.dutyObj.id = ""
    },

    addObligation1 () {
      this.oneClassType = 'add'
      this.obligationShow1 = true
      this.obligationDialog1 = true
      this.dutyObj.dutyClassFee = ""
      this.dutyObj.dutyClassNum = ""
      this.addObj.interpolateName = ''
      this.addObj.planList = []
    },

    addObligation2 () {
      this.oneClassType = 'add'
      this.obligationShow2 = true
      this.obligationDialog2 = true
      this.dutyObj.dutyClassFee = ""
      this.dutyObj.dutyClassNum = ""
      this.addObj1.interpolateName = ''
      this.addObj1.planList = []
    },

    //义务课方案编辑
    editObligation () {
      if (this.addPlan.dutyId) {
          this.obligationShow = false
          this.obligationDialog = true
          axios.get(`${apiBaseUrl}/salaryPlanDuty/detail?id=${this.addPlan.dutyId}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                this.dutyObj.id = res.data.data.id
                this.dutyClassFee = res.data.data.dutyClassNum
                this.dutyClassNum = res.data.data.dutyClassFee
          })
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    editObligation1 () {
      this.oneClassType = ''
      this.obligationDialog1 = true
      this.obligationShow1 = false
      if (this.addPlan.dutyId1) {
          // this.obligationShow = false
          // this.obligationDialog = true
          axios.get(`${apiBaseUrl}/oneClass/oneClassDetails/${this.addPlan.dutyId1}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
            this.dutyObj = res.data.data
            this.addObj.planList = res.data.data.oneClassPlanDTOList
            this.addObj.interpolateName = res.data.data.oneClassName
          })
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    editObligation2 () {
      this.oneClassType = ''

      if (this.addPlan.dutyId2) {
          this.obligationDialog2 = true
          this.obligationShow2 = false
          // this.obligationShow = false
          // this.obligationDialog = true
          axios.get(`${apiBaseUrl}/way_plan/wayDetails/${this.addPlan.dutyId2}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
            this.dutyObj = res.data.data
            this.addObj1.planList = res.data.data.wayPlanDTOList
            this.addObj1.interpolateName = res.data.data.wayMoneyName
            this.addObj1.interpolateNames = res.data.data.educationType
          })
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    delObligation2(){
      if (this.addPlan.dutyId2) {
        axios.delete(`${apiBaseUrl}/way_plan/delete/${this.addPlan.dutyId2}`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }) .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.addPlan.dutyId2 = ""
              axios.get(`${apiBaseUrl}/way_plan/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                this.PlanDutyList2 = res.data.data
              })
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    //义务课时删除
    delObligation () {
      if (this.addPlan.dutyId != '') {
        axios
          .get(`${apiBaseUrl}/salaryPlanDuty/delete?id=${this.addPlan.dutyId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.addPlan.dutyId = ""
              this.salaryPlanDuty()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    delObligation1 () {
      if (this.addPlan.dutyId1) {
        axios.delete(`${apiBaseUrl}/oneClass/delete/${this.addPlan.dutyId1}`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }) .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.addPlan.dutyId1 = ""
              axios.get(`${apiBaseUrl}/oneClass/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                this.PlanDutyList1 = res.data.data
              })
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },

    obligationDialogCle(){
      this.obligationDialog = false
      this.dutyClassFee = ""
      this.dutyClassNum = ""
    },

    obligationSave1(){
      if(this.oneClassType === 'add'){
        axios.post(`${apiBaseUrl}/oneClass/add`,{ oneClassName:this.addObj.interpolateName, oneClassPlanList:JSON.stringify(this.addObj.planList)},{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
            if(res.data.code === 200){
                this.$message.success('添加成功~')
                axios.get(`${apiBaseUrl}/oneClass/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                  this.PlanDutyList1 = res.data.data
                })
                this.obligationDialog1 = false
              }
              else{
                this.$message.error('添加失败~')
              }
        })
      }else{
        axios.put(`${apiBaseUrl}/oneClass/update`,{ id: this.addPlan.dutyId1, oneClassName:this.addObj.interpolateName, oneClassPlanList:JSON.stringify(this.addObj.planList)},{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          if(res.data.code === 200){
                this.$message.success('修改成功~')
                axios.get(`${apiBaseUrl}/oneClass/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                  this.PlanDutyList1 = res.data.data
                })
                this.obligationDialog1 = false
              }
              else{
                this.$message.error('修改失败~')
              }
        })
      }
    },

    obligationSave2(){
      if(this.oneClassType === 'add'){
        axios.post(`${apiBaseUrl}/way_plan/add`,{ educationType:this.addObj1.interpolateNames , wayMoneyName:this.addObj1.interpolateName, wayPlanList:JSON.stringify(this.addObj1.planList)},{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
            if(res.data.code === 200){
                this.$message.success('添加成功~')
                axios.get(`${apiBaseUrl}/way_plan/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                  this.PlanDutyList2 = res.data.data
                })
                this.obligationDialog2 = false
              }
              else{
                this.$message.error('添加失败~')
              }
        })
      }else{
        axios.put(`${apiBaseUrl}/way_plan/update`,{ educationType:this.addObj1.interpolateNames, id: this.addPlan.dutyId2, wayMoneyName:this.addObj1.interpolateName, wayPlanList:JSON.stringify(this.addObj1.planList)},{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          if(res.data.code === 200){
                this.$message.success('修改成功~')
                axios.get(`${apiBaseUrl}/way_plan/getList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
                  this.PlanDutyList2 = res.data.data
                })
                this.obligationDialog2 = false
              }
              else{
                this.$message.error('修改失败~')
              }
        })
      }
    },

    obligationDialogCle1(){
      this.obligationShow1 = false
      this.obligationDialog1 = false
    },

    obligationDialogCle2(){
      this.obligationShow2 = false
      this.obligationDialog2 = false

      this.addObj1 =  {  interpolateName: "",  interpolateNames: "",  planList: [],  }
    },

    //义务课时方案添加  编辑 保存
    obligationSave () {
      let data = {
        dutyClassFee: this.dutyClassNum,
        id: this.dutyObj.id,
        dutyClassNum: this.dutyClassFee
      }
      if (this.obligationShow == true) {
        axios
          .post(`${apiBaseUrl}/salaryPlanDuty/add`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.salaryPlanDuty()
              this.obligationDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
            console.log(res, "添加");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/salaryPlanDuty/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.salaryPlanDuty()
              this.obligationDialog = false
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
            console.log(res, '编辑');
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    // 添加当月内推
    addMoonInterpolat(){

      this.addObj.interpolateName = ''
      this.addObj.planList = []

      this.isShowDialog = true
      this.moonVisible = true

    },
     //确定
    determine () {
      this.addObj.planList[this.index].classNum = this.num + '---' + this.num1
      this.num = 0
      this.num1= 0
      this.isMoonShow = false

    },

     //确定
     determine1 () {
        this.addObj1.planList[this.index].classNum = this.num + '---' + this.num1
        this.num = 0
        this.num1= 0
        this.isMoonShow = false
     },
    clickInp1(index){
      this.index = index
      this.isMoonShow = true
    },

    clickInp(index){
      this.index = index
      this.isMoonShow = true
    },

    clickText () {
    this.num1 = this.text
  },
    addInput1 () {
    this.addObj.planList.push({
      classNum: "",
      classPrice: ''
    });
  },

  addInput2 () {
    this.addObj1.planList.push({
      classNum: "",
      classPrice: '',
      phaseOfStudying: '',
    });
  },
  //减少输入框
  removeItem1 () {
    // if (this.addList.length > 1) {
    this.addObj.planList.pop();
    // } else {
    //   this.addList.splice(0, this.addList.length);
    // }
  },
  removeItem2 () {
    this.addObj1.planList.pop();
  },
  // 编辑当月内推
    editMoonInterpolat(){
      console.log(this.addMoon.dutyId);
      if (this.addMoon.dutyId != '') {
        this.isShowDialog= false
        this.moonVisible = true
        axios
          .get(`${apiBaseUrl}/interpolate/interpolateDetails/${this.addMoon.dutyId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            console.log(res,'回显')
            this.addObj.interpolateName = res.data.data.interpolateName
            this.addObj.planList = res.data.data.interpolatePlanDTOList
            // this.dutyObj = res.data.data
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },
    delMoonInterpolat(){
      if (this.addMoon.dutyId != '') {
        axios.delete(`${apiBaseUrl}/interpolate/delete/${this.addMoon.dutyId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            console.log(res,'删除成功')
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.addMoon.dutyId = ""
              this.getMoonInterpolatList()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请选择一个方案")
      }
    },
    determinePlan(){
        if(this.isShowDialog){
          axios.post(`${apiBaseUrl}/interpolate/add`,{ interpolateName:this.addObj.interpolateName, interpolatePlanList:JSON.stringify(this.addObj.planList)},{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res) => {
            if(res.data.code === 200){
                this.$message.success('添加成功~')
                this.getMoonInterpolatList()
                this.moonVisible = false
            }else{
                this.$message.error('添加失败~')
            }
          })
        }else{
          axios.put(`${apiBaseUrl}/interpolate/update`,{ id: this.addMoon.dutyId, interpolateName:this.addObj.interpolateName, interpolatePlanList:JSON.stringify(this.addObj.planList)},{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res) => {
            if(res.data.code === 200){
                this.$message.success('添加成功~')
                this.getMoonInterpolatList()
                this.moonVisible = false
            }else{
                this.$message.error(res.data.message)
              }
          })
      }


    },
    //获取当月内推奖励列表
    getMoonInterpolatList(){
      axios.get(`${apiBaseUrl}/interpolate/getList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          console.log(res,'获取当月内推奖励列表')
          this.MoonInterpolatList = res.data.data
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取课时费列表
    getListArr () {
      axios
        .post(`${apiBaseUrl}/salaryPlanClassFee/getList`, { pageNum: 1, pageSize: 10 },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.planDetails = res.data.data.records
        })
    },
    //课时费添加 编辑保存
    showSava () {
      if (this.isShow == true) {
        //添加方法方法
        axios
          .post(`${apiBaseUrl}/salaryPlanClassFee/add`, { planName: this.planNames, planDetail: this.arr },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.showDialog = false
              this.$message.success(res.data.message)
              this.getListArr()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        //编辑保存方法
        axios
          .post(`${apiBaseUrl}/salaryPlanClassFee/update`, { planName: this.planNames, planDetail: this.arr, id: this.addPlan.classFeeId },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code == 200) {
              this.showDialog = false
              this.$message.success(res.data.message)
              this.getListArr()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    handleSelectionChange (selection) {
      this.addPlan.gradeOneManyId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },
    handleSelectionChange1 (selection) {
      this.addPlan.execId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },
    handleSelectionChange2 (selection) {
      this.addPlan.exceOnemanyId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },

    handleSelectionChange3 (selection) {
      this.addPlan.exceDayId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },

    handleSelectionChange4 (selection) {
      this.addPlan.studentTotalId = selection.map(item => item.id);// 需要根据数据情况调整id名称
    },
    //添加方案按钮
    addProgramme () {
      this.addPlan.dutyId = '',//义务课时费表id
        this.addPlan.planName = "",//方案名称
        this.addPlan.isRecommender = false,//是否选了内推奖励
        this.addPlan.recommenderFee = "",//内推奖励金额
        this.addPlan.day = "",
        this.addPlan.isDuty = false,
        this.addPlan.isClassFee = false,
        this.addPlan.execId = [],//超课次表id
        this.addPlan.jobBasepay = "",//底薪
        this.addPlan.classFeeId = "",//课时费表id
        this.addPlan.dutyMonth = "",//义务课时费有效期
        this.addPlan.isGradeOneMany = false,//是否选了小学生一对多 0否 1是
        this.addPlan.isExce = false,//是否选了超课次 0否 1是
        this.addPlan.isExceOnemany = false,//是否选了超课次后一对多奖励 0否 1是
        this.addPlan.isExceDay = false,//是否选了当天超课次 0否 1是
        this.addPlan.isStudentTotal = false,//是否选了学生课程累计 0否 1是
        this.addPlan.exceDayId = [],//当天超课次表id
        this.addPlan.exceOnemanyId = [],//超课次一对多奖励表id
        this.addPlan.gradeOneManyId = [],//小学生一对多表id
        this.addPlan.studentTotalId = []//学生课程累计表id
      this.titleText = true
      this.dialogVisible = true
    },

    dialogVisibleCle(){
      // this.$emit('handleEvent',false)
      this.addMoon.isMoon = false
      this.addMoon.dutyId = ''

      this.addPlan.isDay =  false
      this.addPlan.dutyId1 = ''

      this.addPlan.isDuty1 = false
      this.addPlan.day = ''

      this.dialogVisible = false

      this.expandFee  = ''
      this.isExpand  = 0


    },
    clickitem (val) {
      val != this.addPlan.classFeeId ? val == this.addPlan.classFeeId ? this.addPlan.classFeeId = '' : this.addPlan.classFeeId = val : this.addPlan.classFeeId = ""
    },
    clickitem1 (val) {
      val != this.addPlan.dutyId ? val == this.addPlan.dutyId ? this.addPlan.dutyId = '' : this.addPlan.dutyId = val : this.addPlan.dutyId = ""
    },
    clickitem11 (val) {
      val != this.addPlan.dutyId1 ? val == this.addPlan.dutyId1 ? this.addPlan.dutyId1 = '' : this.addPlan.dutyId1 = val : this.addPlan.dutyId1 = ""
    },
    clickitem111 (val) {
      val != this.addPlan.dutyId2 ? val == this.addPlan.dutyId2 ? this.addPlan.dutyId2 = '' : this.addPlan.dutyId2 = val : this.addPlan.dutyId2 = ""
    },
    clickitemtwo(val){
      val != this.addMoon.dutyId ? val == this.addMoon.dutyId ? this.addMoon.dutyId = '' : this.addMoon.dutyId = val : this.addMoon.dutyId = ""
    },
    //所有方案分页
    handleSizeChange (val) {
      this.planList.pageSize = val;
      this.handleinitlist()
      // console.log(val);
    },
    handleCurrentChange (v) {
      // console.log(v);
      this.planList.pageNum = v;
      // this.getPlanList();
      this.handleinitlist()
    },
    //所有方案分页
    handleSizeChange1 (val) {
      // console.log(val);
    },
    handleCurrentChange1 (v) {
      this.GradeOneManyList.pageNum = v;
      // this.getPupilList();
      this.handleinitlist()
    },
    //所有方案分页
    handleSizeChange2 (val) {
      // console.log(val);
    },
    handleCurrentChange2 (v) {
      this.PlanExecList.pageNum = v;
      this.getPlanExec();
    },
    //所有方案分页
    handleSizeChange3 (val) {
      // console.log(val);
    },
    handleCurrentChange3 (v) {
      this.onManyList.pageNum = v;
      this.getOnMany();
    },
    //所有方案分页
    handleSizeChange4 (val) {
      // console.log(val);
    },
    handleCurrentChange4 (v) {
      this.toDayList.pageNum = v;
      this.getToDay();
    },
    //所有方案分页
    handleSizeChange5 (val) {
      // console.log(val);
    },
    handleCurrentChange5 (v) {
      this.studentCoursesList.pageNum = v;
      this.getStudentCourses();
    },
  }
}
</script>

<style scoped lang="less">


/deep/ .el-collapse-item{
  padding-left: 20px;
}
.demo-form-inline {
  display: flex;
}

/deep/ .el-radio__input {
  position: absolute;
  left: -20px;
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}


 /deep/ .el-collapse-item__header {
  font-size: 15px !important;
  font-weight: 900;
}


  
</style>



// WEBPACK FOOTER //
// src/SalescompensationAll/PerformanceCommissionPlanType.vue